import { addLocale, useLocale, gettext, t } from "ttag";
import { VueCookieNext } from "vue-cookie-next";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import "dayjs/locale/kk";

const initLocale = () => {
  const defaultLocale = "ru-RU";
  const locale = VueCookieNext.getCookie("locale") ?? defaultLocale;
  const translationObj = require(`../l10n/${locale}.po.json`);
  addLocale(locale, translationObj);
  useLocale(locale);
  if (locale == "kk-KZ") {
    dayjs.locale("kk");
  } else {
    dayjs.locale("ru");
  }
};

const l10nformat = (str, dict) => {
  if (!str) {
    return "";
  }
  return Object.keys(dict).reduce(
    (acc, key) => acc.replace(`#${key}#`, dict[key]),
    str
  );
};

export { gettext, l10nformat, t };

export default {
  install(app) {
    initLocale();

    app.config.globalProperties.$gettext = gettext;
    app.config.globalProperties.$t = t;
    app.config.globalProperties.$l10nformat = l10nformat;
  },
};
